<template>
  <div class="pdl-detail-edit mt-5" v-if="localPdl">

    <v-row>
      <v-col md="8">
        <v-form @submit.prevent="save">
          <v-row>
            <v-col>
              <v-text-field
                  :label="$t('name')"
                  v-model="localPdl.name"
                  hide-details
              />
            </v-col>
            <v-col>
              <v-text-field
                  :label="$t('pdl.reference')"
                  v-model="localPdl.reference"
                  :hint="$t('pdl.reference-hint')"
                  persistent-hint
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col md="6">
              <v-select
                  :label="$t('pdl.bills')"
                  v-model="localPdl.billsOperator"
                  :items="[
                    {text: $t('pdl.bills-operator'), value: true},
                    {text: $t('pdl.bills-location-organization'), value: false},
                  ]"
                  hide-details
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h4 class="mb-2">{{ $t('price-component.energy-price') }}</h4>
              <pdl-energy-price-module :pdl-id="localPdl.id" />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn small color="error" outlined v-if="!localPdl.isDefault" @click="deletePdl">
                <v-icon small left>mdi-delete</v-icon>
                {{ $t('delete') }}
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn class="mr-3" small :to="{name: 'pdl.detail'}">{{ $t('cancel') }}</v-btn>
              <v-btn small color="primary" type="submit" :disabled="!canSave || loadingSave" :loading="loadingSave">
                {{ $t('save') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import PdlRepository from "@repository/PdlRepository";
import PdlEnergyPriceModule from "@blocks/Pdl/PdlEnergyPriceModule.vue";

export default {
  components: {PdlEnergyPriceModule},

  data() {
    return {
      localPdl: null,
      loadingSave: false,
    }
  },

  mounted() {
    if (!this.currentUser.isZE || !this.currentUser.permissions.includes('STATION_WRITE')) {
      this.$router.replace({name: 'pdl.detail'})
      return
    }
    this.localPdl = this.pdl ? this.cloneObj(this.pdl) : null
  },

  watch: {
    pdl(val) {
      this.localPdl = val ? this.cloneObj(val) : null
    },
  },

  computed: {
    pdl() {
      return this.$parent.pdl ?? null
    },

    canSave() {
      return !!this.localPdl?.name
    },
  },

  methods: {
    save() {
      this.loadingSave = true
      PdlRepository.update(this.localPdl.id, {name: this.localPdl.name, reference: this.localPdl.reference ?? '', billsOperator: this.localPdl.billsOperator}).then(() => {
        this.loadingSave = false
        this.$dialog.notify.success(this.$t('updated-successfully'))
        this.$parent.loadPdl().then(() => {
          this.$router.replace({name: 'pdl.detail'})
        })
      }).catch(e => {
        this.loadingSave = false
        this.notifyError(e)
      })
    },

    deletePdl() {
      this.$dialog.confirm({
        text: this.$t('pdl.delete-confirm'),
      }).then(dialog => {
        if (dialog) {
          PdlRepository.delete(this.localPdl.id).then(() => {
            this.$router.replace({name: 'organizations.pdls', params: {id: this.localPdl.organizationId}})
          }).catch(e => {
            this.notifyError(e)
          })
        }
      })
    },
  }
}
</script>
